import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import { apiToastError, apiToastSuccess } from '@/@core/utils/toast'
import {
  ADD_NICK_NAME,
  UPDATE_NICK_NAME,
} from '@/store/modules/auth.module'

export function useNickName() {
  const saving = ref(false)
  const nickName = ref('')

  const nickNameError = computed(() => {
    if (nickName.value && nickName.value.length < 3) {
      return 'Nickname must be at least 3 characters'
    }
    return ''
  })

  const isNickNameValid = computed(() => nickName.value && !nickNameError.value)

  function initNickName(retailerBrandIdentity) {
    nickName.value = retailerBrandIdentity || ''
  }

  async function submitNickName(retailerId, hasExisting) {
    try {
      saving.value = true
      const payload = {
        retailerId,
        retailerBrandIdentity: nickName.value,
      }
      const endpoint = hasExisting ? UPDATE_NICK_NAME : ADD_NICK_NAME
      const res = await store.dispatch(endpoint, { payload })
      apiToastSuccess(res.data.message)
      return { success: true }
    } catch (err) {
      apiToastError(err)
      return { success: false }
    } finally {
      saving.value = false
    }
  }

  return {
    saving,
    nickName,
    nickNameError,
    isNickNameValid,
    initNickName,
    submitNickName,
  }
}
